module.exports = __webpack_public_path__ + "static/history-b2798c45811ec48f690f04624750bd43.png";